import { Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/authStore';

export function AdminRoute() {
  const { user, isAdmin, loading } = useAuthStore();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center text-muted">
        {t('admin.checking')}
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="grid min-h-screen place-items-center px-6 text-center">
        <div>
          <h1 className="text-2xl font-bold">{t('admin.unauthorized')}</h1>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
